import React from 'react';
import { Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SettingsNavigation from '../../components/settings/SettingsNavigation';

const SettingsLayout: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div data-ui="settings-page" className="page-theme-surface page-theme-settings page-theme-blue-white -mt-2 -ml-3 sm:-ml-4 flex items-stretch min-h-[calc(100vh-1rem)] bg-transparent text-white">
      {/* Secondary Settings Sidebar flush next to Sidebar.tsx */}
      <aside data-ui="settings-navigation" className="hidden lg:flex lg:w-64 shrink-0 bg-black/50 backdrop-blur-xl p-5 border-r border-white/10 flex-col space-y-3 min-h-[calc(100vh-1rem)] sticky top-0 self-start shadow-inner-glow shadow-inner-glow-black-md">
        {/* Header Icon & Title without outlines */}
        <div data-ui="settings-layout-region-001" className="flex items-center gap-3 px-2 pb-4 border-b border-white/10 shrink-0">
          <div data-ui="settings-layout-region-002" className="w-9 h-9 rounded-xl bg-blue-600/30 text-blue-300 flex items-center justify-center shrink-0 border-none shadow-inner-glow shadow-inner-glow-white-sm">
            <FontAwesomeIcon icon={faCog} className="w-4 h-4" />
          </div>
          <h2 className="text-base font-bold text-white tracking-tight">
            {t('settings.title', 'Ajustes Generales')}
          </h2>
        </div>

        <SettingsNavigation />
      </aside>

      {/* Main Content Area */}
      <main data-ui="settings-content" className="flex-1 w-full p-4 sm:p-6 lg:p-8 overflow-y-auto min-h-[calc(100vh-1rem)]">
        <div data-ui="settings-layout-region-003" className="max-w-4xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SettingsLayout;
